import { makeObservable, observable } from 'mobx'
import { IShopifyAddress, IShopifyMailingAddressInput } from '../interfaces'
import { retrieveFromWindow } from '../utils'

const customerId: number = retrieveFromWindow('customerId')
const customerAddresses: IShopifyAddress[] = retrieveFromWindow('customerAddresses', [])
const customerPreferredDeliveryDay = retrieveFromWindow('preferredDeliveryDay', false)
const defaultCustomerAddress: IShopifyAddress | null = retrieveFromWindow('defaultCustomerAddress')
const tags = retrieveFromWindow('customerTags', [])
const orderHistoryLength = retrieveFromWindow('orderHistoryLength', 0)

class CustomerStore {
  id: number = customerId
  customerPreferredDeliveryDay: string = customerPreferredDeliveryDay
  addresses: IShopifyAddress[] = customerAddresses
  defaultAddress: IShopifyAddress | null = this.initializeDefaultAddress
  tags: string[] = tags
  orderHistoryLength: number = orderHistoryLength

  constructor() {
    makeObservable(this, {
      addresses: observable,
      defaultAddress: observable
    })
  }

  get initializeDefaultAddress(): IShopifyAddress | null {
    if (defaultCustomerAddress) {
      return defaultCustomerAddress
    }
    if (this.addresses.length > 0) {
      const defaultAddresses = this.addresses.filter((address) => address.default)
      return defaultAddresses.length > 0 ? defaultAddresses[0] : this.addresses[0]
    }
    return null
  }

  get formatAddressForApi(): IShopifyMailingAddressInput {
    const {
      address1,
      address2,
      city,
      company,
      country,
      first_name: firstName,
      last_name: lastName,
      phone,
      province,
      zip
    } = this.defaultAddress || {}

    return {
      address1,
      address2,
      city,
      company,
      country,
      firstName,
      lastName,
      phone,
      province,
      zip
    }
  }
}

export const customerStore = new CustomerStore()
